import React from 'react';

import * as S from "../styles";
import alertIcon from "../icons/alert-circle.svg";
import useTypedSelector from "../hooks/useTypedSelector";
import useBannerVisible from "../hooks/useBannerVisible";

const BetaBanner: React.FC = () => {
    const bannerMessage = useTypedSelector(state => state.toggles.bannerMessage);
    const isBannerActive = useBannerVisible();

    return isBannerActive ? (
        <S.GlobalBanner>
            <S.GlobalBannerChildWrapper>
                <S.Icon src={alertIcon} />
                <div>
                    <p style={{color:'white'}}>{bannerMessage}</p>
                </div>
            </S.GlobalBannerChildWrapper>
        </S.GlobalBanner>
    ) : null;
};

export default BetaBanner;